var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#E7B178",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 36C63 51.4973 50.8789 64 36 64C21.1211 64 9 51.4973 9 36C9 20.5027 21.1211 8 36 8C50.8789 8 63 20.5027 63 36Z",
    fill: "#E8ECF0",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9341 57.5695L18.9003 56.6821L20.7909 54.5355L50.8523 54.7987L52 57C41.4335 69.5739 25.5433 62.666 19.9341 57.5695Z",
    fill: "#CECCEF",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57C52 49.2119 43.3017 42.8811 35.5 42.8811C27.6983 42.8811 19 49.2119 19 57M35.5 35.8238C38.0005 35.8238 40.3986 34.8322 42.1668 33.0671C43.9349 31.302 44.9283 28.9081 44.9283 26.4119C44.9283 23.9157 43.9349 21.5218 42.1668 19.7567C40.3986 17.9916 38.0005 17 35.5 17C32.9995 17 30.6014 17.9916 28.8332 19.7567C27.0651 21.5218 26.0717 23.9157 26.0717 26.4119C26.0717 28.9081 27.0651 31.302 28.8332 33.0671C30.6014 34.8322 32.9995 35.8238 35.5 35.8238Z",
    fill: "#CECCEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57C52 49.2119 43.3017 42.8811 35.5 42.8811C27.6983 42.8811 19 49.2119 19 57M35.5 35.8238C38.0005 35.8238 40.3986 34.8322 42.1668 33.0671C43.9349 31.302 44.9283 28.9081 44.9283 26.4119C44.9283 23.9157 43.9349 21.5218 42.1668 19.7567C40.3986 17.9916 38.0005 17 35.5 17C32.9995 17 30.6014 17.9916 28.8332 19.7567C27.0651 21.5218 26.0717 23.9157 26.0717 26.4119C26.0717 28.9081 27.0651 31.302 28.8332 33.0671C30.6014 34.8322 32.9995 35.8238 35.5 35.8238Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.50237494101f62aa307277c010edeb53.svg";
export { ForwardRef as ReactComponent };